<div *ngIf="pageDesignFlag">
  <div id="{{pageDesign.name}}" [ngStyle]="pageDesign.style" (keydown)="keyboardEvent($event, form)">

    <div class="row" id="start-action-button-container"  *ngIf="pageDesign.back_button">
      <div>
        <img src="assets/images/back-arrow.png" class="back-button" alt="" srcset=""  (click)="goBack()">
      </div>
    </div>

    <div class="full-width">

      <!-- CUSTOM CODE SECTION -->
      <div *ngIf="customDesign">
          
        <div [innerHTML]="htmlText | sanitizeHtml"></div>

      </div>

      <!-- NON CUSTOM CODE SECTION -->
      <div *ngIf="!customDesign">


          <div *ngFor="let ele of pageDesign.element_flow" style="width: 100%;">

            <p *ngIf="ele.type=='text' && ele.text !=''" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
            <p *ngIf="ele.type=='link'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml">&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
        
            <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
            <button mat-raised-button *ngIf="ele.type=='button'" type="button" [ngStyle]="ele.style"
              (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml"></button>
        
            <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
              (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml">
            </label>
            
            <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/*"
              (change)="fileProgress($event)" #photoInput />
        
          </div>

          
          <form [formGroup]="form">

            <div *ngFor="let field of form_fields" style="width: 100%;">
                
              <div *ngIf="field.category=='form_input'">

                <div [ngSwitch]="field.type">

                  <div class="input-div" *ngSwitchCase="'text'">
              
                    <mat-form-field class="full-width"  appearance = "{{field.matApperance}}">
              
                      <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
              
                      <input [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value"  [ngStyle]="field.style" matInput>
              
                      <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                      <mat-error *ngIf="checkError(field.key, 'required')" i18n>{{field.key}} is required</mat-error>

                    </mat-form-field>

                  </div>
                  
                  <div class="input-div" *ngSwitchCase="'phone'">

                    <div *ngIf="!country_code_activated">
                      
                      <mat-form-field class="full-width" appearance = "{{field.matApperance}}">
              
                        <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
                
                        <input [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value"  [ngStyle]="field.style" matInput>
                
                        <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                        <mat-error *ngIf="checkError(field.key, 'required')" i18n>{{field.key}} is required</mat-error>
                  
                      </mat-form-field>

                    </div>

                    <!-- WHEN COUNTRY CODE IS REQUIRED -->
                    <div *ngIf="country_code_activated">
                    
                      <div id="country_code_format">

                        <div>
                        
                          <mat-form-field appearance = "{{field.matApperance}}">
                        
                            <mat-select [formControl]="countryCtrl" placeholder="Country" #singleCountrySelect (selectionChange)="changeCountry(singleCountrySelect)">
                        
                              <mat-option>
                                <ngx-mat-select-search placeholderLabel="Country search" noEntriesFoundLabel="'No matching country found'" [formControl]="countryFilterCtrl" placeholder="Country search"></ngx-mat-select-search>
                              </mat-option>

                              <mat-option *ngFor="let country of filteredCountries | async" [value]="country">
                                {{country.name}} {{country.countryCode}} 
                              </mat-option>

                            </mat-select>
                            
                          </mat-form-field>

                        </div>

                        <div>
                                
                          <mat-form-field class="full-width" id="country_code_format_parent"  appearance = "{{field.matApperance}}">
                            
                            <mat-label [ngStyle]="{color: hintColor}" id="country_code_format_label">{{field.label}}</mat-label>
                            
                            <input [formControlName]="field.key" [id]="field.key" type="phone" [value]="field.value" maxlength="20"  [ngStyle]="field.style" matInput>
                            
                            <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>
                          
                            <mat-error *ngIf="checkError(field.key, 'required')" i18n>Contact number is required</mat-error>

                          </mat-form-field>

                        </div>

                      </div>

                    </div>

                  </div>

                  <div class="input-div" *ngSwitchCase="'number'">
              
                    <mat-form-field class="full-width" appearance = "{{field.matApperance}}">
              
                      <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
              
                      <input [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value" [required]="field.required"  [ngStyle]="field.style" matInput>
              
                      <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                      <mat-error *ngIf="checkError(field.key, 'required')" i18n>{{field.key}} is required</mat-error>

                    </mat-form-field>

                  </div>
                  
                  <div class="input-div" *ngSwitchCase="'dropdown'">
              
                    <select [id]="field.key" [formControlName]="field.key" class="select-box">
              
                      <option disabled>{{field.label}}</option>
              
                      <option *ngFor="let opt of field.options" placeholder="field.label" [value]="field.key">{{field.key}}</option>
                    
                    </select>
                  
                  </div>

                  <div  class="input-div" *ngSwitchCase="'textarea'">
            
                    <mat-form-field class="full-width"  appearance = "{{field.matApperance}}">
            
                      <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
            
                      <textarea [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value" matInput [rows]="field.rowcount"  [ngStyle]="field.style" ></textarea>
            
                      <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                      <mat-error *ngIf="checkError(field.key, 'required')" i18n>{{field.key}} is required</mat-error>

                    </mat-form-field>
            
                  </div>
      
                  <div class="input-div" *ngSwitchCase="'date'">

                    <mat-form-field  class="full-width" appearance = "{{field.matApperance}}">
                      
                      <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
                      
                      <input [formControlName]="field.key" (focus)="picker.open()" (click)="picker.open()" [value]="field.value" [id]="field.key" matInput [matDatepicker]="picker" (keydown)="false"  [ngStyle]="field.style">
                      
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      
                      <mat-datepicker #picker></mat-datepicker>

                      <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>

                      <mat-error *ngIf="checkError(field.key, 'required')" i18n>Date is required</mat-error>

                    </mat-form-field>
              
                  </div>

                  <div class="input-div" *ngSwitchCase="'email'">
              
                    <mat-form-field class="full-width" appearance = "{{field.matApperance}}">
              
                      <mat-label [ngStyle]="{color: hintColor}">{{field.label}}</mat-label>
              
                      <input [formControlName]="field.key" [id]="field.key" [type]="field.type" [value]="field.value"  [ngStyle]="field.style" email matInput>
              
                      <mat-hint *ngIf="field.hint!=''">{{field.hint}}</mat-hint>
                      
                      <mat-error *ngIf="checkError(field.key, 'required')" i18n>Email is required</mat-error>
                      <mat-error *ngIf="checkError(field.key, 'pattern')" i18n>Valid email is required</mat-error>

                    </mat-form-field>
                  </div>      

                </div>

              </div>

              <button mat-raised-button *ngIf="field.category=='form_submit'" type="button" [ngStyle]="field.style"
              (click)="submitFunction(field,form)">{{field.text}}</button>
        
              <button mat-raised-button *ngIf="field.category=='button'" type="button" [ngStyle]="field.style"
              (click)="callButtonFunction(field)">{{field.text}}</button>
        
              <p *ngIf="field.category=='form_text' && field.text !=''" [ngStyle]="field.style">{{field.text}}</p>
              
              <div *ngIf="field.category=='form_custom_element'" [innerHTML]="field.customHtml | sanitizeHtml" [ngStyle]="field.style"></div>
              
            </div>
          
          </form>
        
      </div>

    </div>
    
  </div>
</div>